// extracted by mini-css-extract-plugin
module.exports = {"submenu":"Submenu_submenu__3aCQo","submenuRight":"Submenu_submenuRight__vMiv4"};